import {
  SLACK_LOGOUT
} from '../actions/slack-action';

const initialState = {
  slack_logout : false
}

export default function slack(state = initialState, action = {}) {

  switch (action.type) {
    case SLACK_LOGOUT:
      return {
        ...state,
        slack_logout : true
      }
    default:
      return state;
  }
}
